import React, {useState, useEffect} from 'react'
import {Button} from 'react-bootstrap'


const ToDate = ({value}) => {
    let date = new Date(value)
    let text = date ? `${date.getYear()-100}-${date.getMonth()+1}-${date.getDate()}` : ""

    return (
        <td value={value} style={{ width:"6rem" }}>
            {text}
        </td>
    )
}

const ToId = ({value, onClick, crud=0, selelcetd=0}) => {  
    const bstyle = { width: '2rem', display: 'block', padding:'0.2rem', textAlign:'right' }  
    
    let bvariant = (crud===2) ? "outline-info" : "outline-warning"
    if(selelcetd>0 && selelcetd===value)
        bvariant = bvariant.replace("outline-","")

    return (
<td key={value} value={value}>
    <Button value={value} variant={bvariant} style={bstyle}
        onClick={onClick}
    >{value}</Button>      
</td>
 )
}

const ToClick = ({value, text, onClick}) => {    
    return (
<td key={value} value={value}>
    <Clickable {...{value,text,onClick}} />
</td>
 )
}

const Clickable = ({value, text, onClick}) => {
    return (
        <Button value={value} variant="outline-info" style={{ maxWidth:"100%", textAlign:"right" }}
            onClick={onClick}
        >{text}</Button>      
    )        
}

const ToNotify = ({message,onClose,onEtat=null}) => {
    let open = message && message.length>0

    if(open) {
        onEtat && onEtat(message)
    }

    return (

    open ? 
        <NotifyControl 
        open={open}
        message={message}
        onClose={onClose}
        /> 
    : null 

    )
}


const ScrollTo = ({to, label, style}) => {

    const scrollTo = (to) => { 
        const element = document.getElementById(to); 
        if (element) { 
            element.scrollIntoView({ behavior: 'smooth' }); 
        } };
    
    return (
        <nav className="navbar" style={style}> <a href={`/#${to}`} onClick={scrollTo}>{label??to}</a></nav>
    )
}

export {ScrollTo, ToNotify, ToDate, ToId, ToClick, Clickable}

// expected one of "default","inherit","primary","secondary"
const NotifyControl = ({open,message,onClose}) => {
    const [timer, Timer] = useState(null)
    let color="default"
    let type=""
    let duration=3000
    if(message && message.length>1)
    {
        type= message.slice(message.length - 1)        
        switch(type) {
            case '!':
                color="teal"  //"success"
              break;
            case '?':
                duration=6000
                color="coral"
              break;
            case '.':
                color="gray"
              break;
            default:
                color="default"
          }
    }

//  this it better    
    useEffect(() => {
        if(timer===null && type.length>0) {
            //console.log("setTimeout",duration)
            Timer(setTimeout(() => {
                onClose && onClose()
            }, duration))
            
            return () => { clearTimeout(timer); Timer(null); }
        }
    },[timer, message])
    
/*
//  this it right 
    useEffect(() => {
        console.log("setTimeout",duration)
        const timer = setTimeout(() => {
            onClose && onClose()
          //console.log('This will run after 1 second!')
        }, duration);
        return () => clearTimeout(timer);
      }, []);
*/

    return (
        open ? 
        <Button key="NotifyControl"
             style={{
                backgroundColor: color, position:'fixed', bottom:'10%', left:'30%', width:'40%', height:'auto', zIndex:'9999', fontSize:'1.1rem'
              }}
              onClick={onClose}
        >
            {message}
        </Button>     
        : null   
    )
}

